import axios from "axios";

export function SetRewardUpdateStatus({
  id,
  status,
}) {
  const url = `/distributor/admin/api/v1/rewards/${id}/update-status`;

  return new Promise((resolve, reject) => {
    axios.post(url, {
      status: status,
    })
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}